module.exports = __webpack_public_path__ + "static/img/SE.d5c3d253.svg";